export var fontScale = {
    milkyWay: {
        size: 96,
        lineHeight: 96,
    },
    superNova: {
        size: 72,
        lineHeight: 72,
    },
    nova: {
        size: 52,
        lineHeight: 60,
    },
    sun: {
        size: 46,
        lineHeight: 60,
    },
    jupiter: {
        size: 38,
        lineHeight: 48,
    },
    earth: {
        size: 24,
        lineHeight: 36,
    },
    mars: {
        size: 18,
        lineHeight: 24,
    },
    moon: {
        size: 16,
        lineHeight: 24,
    },
    pluto: {
        size: 14,
        lineHeight: 22,
    },
    asteroid: {
        size: 12,
        lineHeight: 16,
    },
    dust: {
        size: 10,
        lineHeight: 12,
    },
};
//# sourceMappingURL=fontScale.js.map